<template>
  <div class="action-input">
    <div class="action-input__input">
      <v-input
        v-model="value"
        :disabled="disabled"
        :label="label"
      ></v-input>
    </div>
    <div class="action-input__button">
      <v-button width="full" @click="click">{{ actionText }}</v-button>
    </div>
  </div>
</template>

<script>
import vInput from '@/ui/controls/vInput'
import vButton from '@/ui/controls/vButton'

export default {
  components: {
    vInput,
    vButton
  },
  props: {
    /**
     * @model
     */
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    actionText: {
      type: String
    }
  },
  methods: {
    click () {
      this.$emit('click', this.value)
    }
  }
}

</script>

<style lang="scss">
.action-input {
  display: flex;
  flex-wrap: wrap;
  margin-left: -1rem;
  margin-right: -1rem;
  &__input {
    padding: 1rem;
    width: 100%;
    @include respond(tab-port) {
      width: 75%;
    }
  }
  &__button {
    padding: 1rem;
    width: 100%;
    @include respond(tab-port) {
      width: 25%;
    }
  }
}
</style>
